var render = function render(){var _vm=this,_c=_vm._self._c;return _c('df-exam',{attrs:{"steps":_vm.getSteps(),"input":_vm.loadCheckData(_vm.assessment),"disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }